import { useState, useEffect, useRef } from "react";
import { useInView, motion } from "framer-motion";
import { toast } from "react-toastify";
import "./Events.scss";
import backgroundImage from "../../Assets/images/img18.jpg";
import EventsCard from "../Events/EventCard";

const API_URL = process.env.REACT_APP_API_URL;

const Events = () => {
  const [loading, setLoading] = useState(true);
  const titleRef = useRef(null);
  const isInView = useInView(titleRef, {
    once: true,
    amount: 0.1,
  });

  const [announcements, setAnnouncements] = useState([]);

  useEffect(() => {
    const fetchAnnouncements = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${API_URL}/events`);
        if (response.ok) {
          let data = await response.json();
          // Sort announcements by date and time in descending order
          data = data.sort((a, b) => {
            const dateA = new Date(`${a.date}T${a.time}`);
            const dateB = new Date(`${b.date}T${b.time}`);
            return dateB - dateA; // Most recent first
          });
          setAnnouncements(data);
        } else {
          toast.error("Failed to fetch events.");
        }
      } catch (error) {
        toast.error("An error occurred while fetching events.");
      } finally {
        setLoading(false);
      }
    };
    fetchAnnouncements();
  }, []);

  return (
    <section className="events-section">
      <div
        className="services-banner"
        style={{
          backgroundImage: `url(${backgroundImage})`,
        }}
      >
        <div className="services-overlay" />
        <div className="services-text container text-left">
          <motion.div
            ref={titleRef}
            initial={{ opacity: 0, y: 100 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.99, ease: "easeOut", delay: 0.2 }}
          >
            <h5>EVENTS</h5>
          </motion.div>
        </div>
      </div>

      <div className="white-container">
        <div className="inner-container"></div>
      </div>

      <div className="events-title">
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.99, ease: "easeOut", delay: 0.2 }}
          viewport={{ once: true }}
        >
          <h4>
            Where every gathering tells a story <br /> Our event gallery
          </h4>
        </motion.div>
      </div>

      <div className="events-content container">
        {loading ? (
          <div className="spinnerContainer">
            <div className="spinner"></div>
            <div className="loader">
              <p>Loading</p>
              <div className="words">
                <span className="word">requests</span>
                <span className="word">cookies</span>
                <span className="word">headers</span>
                <span className="word">caching</span>
                <span className="word">sessions</span>
              </div>
            </div>
          </div>
        ) : (
          <>
            {announcements.map((announcement) => (
              <div key={announcement.id}>
                <EventsCard announcement={announcement} />
              </div>
            ))}
          </>
        )}
      </div>
    </section>
  );
};

export default Events;
